// Availability comes from the server: completion alone never grants issued drawings.
export function safeMaterialsLink(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  if (/^\/(?!\/)/.test(value)) return value;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}

export function applicationMaterials(order) {
  if (Object.prototype.hasOwnProperty.call(order || {}, 'materials')) {
    const data = order.materials;
    const url = safeMaterialsLink(data?.url);
    if (!url || !['initial', 'ready', 'payment_required'].includes(data?.state)) return null;
    const ready = data.state === 'ready' && data.result_ready === true;
    return {...data, url, ready, state: ready ? 'ready' : data.state === 'payment_required' ? 'payment_required' : 'initial'};
  }
  // Old API compatibility. New responses, including unavailable, always win.
  const drawing = order?.status === 'completed' ? safeMaterialsLink(order.drawing_link) : '';
  if (drawing) return {url: drawing, ready: true, state: 'ready'};
  const media = ['on_drawing', 'completed', 'revision'].includes(order?.status) ? safeMaterialsLink(order.media_link) : '';
  return media ? {url: media, ready: false, state: 'initial'} : null;
}
